import Alex from '/z30-images/robot-s.png';
import { useHelpChat } from './HelpChatProvider';

/** Kept for backwards compatibility; no longer used since Help is a drawer. */
export function getCachedHasIncompleteTodos(): boolean {
  return false;
}

export function HelpAgentTrigger() {
  const { isOpen, toggle } = useHelpChat();

  if (isOpen) return null;

  return (
    <button
      type="button"
      onClick={toggle}
      data-tour="help-agent"
      className="fixed bottom-6 right-6 z-40 hidden h-14 items-center gap-2 rounded-xl pl-4 pr-3 shadow-lg transition-transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:flex"
      style={{
        backgroundColor: 'white',
        border: '1px solid #1a5172',
      }}
      aria-label="Open help"
    >
      <span className="whitespace-nowrap text-sm font-medium text-[#1a5172]">Chat with Alex</span>
      <img src={Alex} alt="Alex" className="mt-1 h-10 w-10 flex-shrink-0 object-contain" />
    </button>
  );
}
